export default __webpack_public_path__ + "locales/sq-AL/About.json?hash=dd2fac85dccf4911d4577c0c978560c8";